module.exports = __webpack_public_path__ + "static/media/11.e042e1dc.jpeg";